import React from 'react';
import ReactGA from 'react-ga';
import TitledBox from '../titled_box/titled_box';
import COLORS from '../../theme/colors';

import GA from '../../services/ga_events';

import './login.scss';

export default function Login() {
  return (
    <div className="login">
      <TitledBox
        title={<div className="login-title">SIGN IN</div>}
        content={
          <div className="login-content">
            Sign in to add Teamhub and let your team create their Slack and Webex news.

            <a
              className="login-button login-slack-button"
              href="/api/auth/dashboard/slack"
              onClick={() => {
                ReactGA.event(GA.loginSlack);
              }
              }
            >
              <div className="button-logo button-slack-logo" />
              Sign in with Slack
            </a>


            <a
              href="/api/auth/dashboard/google"
              className="login-button login-google-button"
              onClick={() => {
                ReactGA.event(GA.loginGoogle);
              }
              }
            >
              <div className="button-logo button-google-logo" />
              Sign in with Google
            </a>

            <a
              href="/api/auth/dashboard/webex"
              className="login-button login-webex-button"
              onClick={() => {
                ReactGA.event(GA.loginWebex);
              }
              }
            >
              <div className="button-logo button-webex-logo" />
              Sign in with Webex
            </a>
          </div>
        }
        color={COLORS.blue}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/login/login.jsx